import "./ResponseContentClosed.css";
import { FormClosedReason } from "../form-collect/FormCollect"; 
import { Branding } from "../form-widgets/Branding";


type ResponseContentClosedProps = {
    closedReason: FormClosedReason;
}

export const ResponseContentClosed = ({closedReason} : ResponseContentClosedProps) => {
    return (
        <div className="response-content-closed">
            <div className="response-content-closed-title">
                This <b>effno</b> form is now closed 🥲
            </div>
            <div className="response-content-closed-content">
               Too bad you didn't see it as it was made with <a href="https://effno.co">effno forms</a> which means it was awesome.
            </div>
            <div className="response-content-closed-cta">
                <button
                    onClick={() => window.open("https://effno.com", "_blank")}
                >
                    Check out effno forms
                </button>
            </div>
        
        </div>
    )
}